import { jarallax } from 'jarallax';
import React, { useEffect, useState } from 'react';
import { bgImgFromData } from '../../lib/helpers';
import { Link } from 'react-router-dom';
import api from '../../lib/api';
import { Formik, Form, Field, ErrorMessage } from 'formik';

const BannerThree = () => {
  const [formStatus, setFormStatus] = useState({ success: '', error: '' });

  useEffect(() => {
    bgImgFromData();
  }, []);

  // jarallax
  useEffect(() => {
    jarallax(document.querySelectorAll('.jarallax'), {
      speed: 0.2,
    });
  }, []);

  const initialValues = {
    name: '',
    email: '',
    phoneNumber: '',
    service: '',
  };

  const validate = (values) => {
    const errors = {};
    if (!values.name.trim()) {
      errors.name = 'Name is required';
    }
    if (!values.email.trim()) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = 'Email is invalid';
    }
    if (!values.phoneNumber.trim()) {
      errors.phoneNumber = 'Phone number is required';
    } else if (!/^\d{10}$/.test(values.phoneNumber.replace(/[^\d]/g, ''))) {
      errors.phoneNumber = 'Please enter a valid 10-digit phone number';
    }
    if (!values.service) {
      errors.service = 'Please select a service';
    }
    return errors;
  };

  const handleSubmit = async (values, { resetForm }) => {
    try {
      await api.post('/enquiry', values);
      resetForm();
      setFormStatus({
        success: 'Thank you! We will contact you soon.',
        error: '',
      });
    } catch (error) {
      console.error('Error submitting form:', error);
      setFormStatus({
        success: '',
        error: 'There was an error submitting the form. Please try again.',
      });
    }
  };

  return (
    <section
      className="banner-area-three jarallax banner-bg-three"
      data-background="/img/new-images/banner-new.jpg"
    >
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-6 col-md-10 order-0 order-lg-2">
            <div className="banner-form-wrap">
              <h2 className="title">Get a Free Estimate</h2>

              <Formik
                initialValues={initialValues}
                validate={validate}
                onSubmit={handleSubmit}
              >
                {() => (
                  <Form>
                    {formStatus.success && (
                      <div className="alert alert-success mb-4">
                        {formStatus.success}
                      </div>
                    )}
                    {formStatus.error && (
                      <div className="alert alert-danger mb-4">
                        {formStatus.error}
                      </div>
                    )}
                    <div className="form-grp">
                      <Field type="text" name="name" placeholder="Your name" />
                      <ErrorMessage name="name">
                        {(msg) => (
                          <span
                            className="error-message"
                            style={{ color: 'red', fontSize: '12px' }}
                          >
                            {msg}
                          </span>
                        )}
                      </ErrorMessage>
                    </div>
                    <div className="form-grp">
                      <Field
                        type="email"
                        name="email"
                        placeholder="Email address"
                      />
                      <ErrorMessage name="email">
                        {(msg) => (
                          <span
                            className="error-message"
                            style={{ color: 'red', fontSize: '12px' }}
                          >
                            {msg}
                          </span>
                        )}
                      </ErrorMessage>
                    </div>
                    <div className="form-grp">
                      <Field
                        type="tel"
                        name="phoneNumber"
                        placeholder="Phone number"
                      />
                      <ErrorMessage name="phoneNumber">
                        {(msg) => (
                          <span
                            className="error-message"
                            style={{ color: 'red', fontSize: '12px' }}
                          >
                            {msg}
                          </span>
                        )}
                      </ErrorMessage>
                    </div>
                    <div className="form-grp">
                      <Field
                        as="select"
                        id="shortBy"
                        name="service"
                        className="form-select"
                        aria-label="Default select example"
                      >
                        <option value="">Select Service</option>
                        <option value="hospitality">
                          Hospitality Cleaning
                        </option>
                        <option value="Office Cleaning">Office Cleaning</option>
                        <option value="Retail Store Cleaning">
                          Retail Store Cleaning
                        </option>
                        <option value="Industrial Cleaning">
                          Industrial Cleaning
                        </option>
                        <option value="Warehouse Cleaning">
                          Warehouse Cleaning
                        </option>
                        <option value="Restaurant Cleaning">
                          Restaurant Cleaning
                        </option>
                        <option value="Carpet Cleaning">Carpet Cleaning</option>
                        <option value="Upholstery Cleaning">
                          Upholstery Cleaning
                        </option>
                        <option value="Window Washing">Window Washing</option>
                        <option value="Post-Construction Cleaning">
                          Post-Construction Cleaning
                        </option>
                        <option value="Disinfection & Sanitization">
                          Disinfection & Sanitization
                        </option>
                        <option value="Ceiling Tiles Repair">
                          Ceiling Tiles Repair
                        </option>
                        <option value="High Dusting">High Dusting</option>
                        <option value="Power Washing">Power Washing</option>
                        <option value="Day Porter Services">
                          Day Porter Services
                        </option>
                      </Field>
                      <ErrorMessage name="service">
                        {(msg) => (
                          <span
                            className="error-message"
                            style={{ color: 'red', fontSize: '12px' }}
                          >
                            {msg}
                          </span>
                        )}
                      </ErrorMessage>
                    </div>
                    <button type="submit" className="btn btn-two">
                      Submit Your Request
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="banner-content-three">
              <h1
                className="title"
                data-aos="fade-right"
                data-aos-delay="0"
                style={{ color: '#333', fontWeight: '50', fontSize: '50px' }}
              >
                Professional
              </h1>

              <h1 style={{ fontSize: '60px', marginTop: '-20px' }}>
                Cleaning Services <br />
                for Businesses
              </h1>

              <div>
                <div
                  className="introduction-list"
                  style={{ borderColor: '#1239ac' }}
                >
                  <ul className="list-wrap">
                    <li>
                      <i className="fas fa-check-circle"></i>Experienced &amp;
                      Trusted Cleaners
                    </li>
                    <li>
                      <i className="fas fa-check-circle"></i>Eco-Friendly
                      Cleaning Products
                    </li>
                    <li>
                      <i className="fas fa-check-circle"></i>100% Satisfaction
                      Guaranteed
                    </li>
                    <li>
                      <i className="fas fa-check-circle"></i>Affordable &
                      Transparent Pricing
                    </li>
                  </ul>
                </div>
              </div>

              <div
                className="banner-btn"
                data-aos="fade-right"
                data-aos-delay="600"
              >
                <Link to="/services" className="btn">
                  Discover MORE
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerThree;
